export const styles = {
  app: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #eef4ff 0%, #f8fbff 100%)",
    padding: "24px",
    fontFamily: "Arial, sans-serif",
    color: "#1e293b",
  },

  centralLoading: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f4f7fb",
    padding: "24px",
  },

  loadingBox: {
    background: "#ffffff",
    borderRadius: "18px",
    padding: "24px 32px",
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08)",
    fontWeight: "700",
    fontSize: "16px",
  },

  authContainer: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #f4f7fb 0%, #eaf1fb 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },

  authBox: {
    width: "100%",
    maxWidth: "430px",
    background: "#ffffff",
    borderRadius: "24px",
    padding: "32px",
    boxShadow: "0 18px 45px rgba(15, 23, 42, 0.10)",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    border: "1px solid #e5e7eb",
  },

  logoImagemAuth: {
    width: "88px",
    height: "88px",
    objectFit: "contain",
    margin: "0 auto 4px auto",
    display: "block",
  },

  authTitulo: {
    margin: 0,
    textAlign: "center",
    fontSize: "30px",
    fontWeight: "800",
    color: "#0f172a",
  },

  authSubtitulo: {
    margin: "0 0 8px 0",
    textAlign: "center",
    color: "#64748b",
    fontSize: "14px",
  },

  topo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    marginBottom: "24px",
    background: "#ffffff",
    borderRadius: "22px",
    padding: "18px 20px",
    boxShadow: "0 10px 28px rgba(15, 23, 42, 0.06)",
    border: "1px solid #e5e7eb",
    flexWrap: "wrap",
  },

  topoEsquerda: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },

  logoImagemTopo: {
    width: "58px",
    height: "58px",
    objectFit: "contain",
    borderRadius: "14px",
  },

  tituloPainel: {
    margin: 0,
    fontSize: "26px",
    fontWeight: "800",
    color: "#0f172a",
  },

  subtituloPainel: {
    margin: "4px 0 0 0",
    color: "#64748b",
    fontSize: "14px",
  },

  card: {
    background: "#ffffff",
    borderRadius: "22px",
    padding: "22px",
    marginBottom: "20px",
    boxShadow: "0 10px 28px rgba(15, 23, 42, 0.06)",
    border: "1px solid #e5e7eb",
  },

  cardHeaderSimples: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    marginBottom: "18px",
    flexWrap: "wrap",
  },

  cardTitulo: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "800",
    color: "#0f172a",
  },

  cardDescricao: {
    margin: "6px 0 0 0",
    color: "#64748b",
    fontSize: "14px",
  },

  subSecaoTitulo: {
    marginTop: "24px",
    marginBottom: "12px",
    fontSize: "18px",
    fontWeight: "800",
    color: "#0f172a",
  },

  gridResumo: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "14px",
    marginBottom: "20px",
  },

  cardResumo: {
    background: "linear-gradient(135deg, #ffffff 0%, #f3f7ff 100%)",
    borderRadius: "18px",
    padding: "18px",
    border: "1px solid #dbe7ff",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)",
  },

  cardResumoTitulo: {
    display: "block",
    color: "#64748b",
    fontSize: "13px",
    marginBottom: "8px",
  },

  cardResumoValor: {
    fontSize: "24px",
    fontWeight: "800",
    color: "#163e7a",
  },

  gridInsights: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "14px",
    marginBottom: "20px",
  },

  insightCard: {
    background: "linear-gradient(135deg, #163e7a 0%, #1d4f91 45%, #2563eb 100%)",
    color: "#ffffff",
    borderRadius: "20px",
    padding: "18px",
    boxShadow: "0 14px 30px rgba(22, 62, 122, 0.20)",
  },

  insightTitulo: {
    display: "block",
    fontSize: "13px",
    color: "rgba(255,255,255,0.78)",
    marginBottom: "10px",
  },

  insightValor: {
    display: "block",
    fontSize: "22px",
    fontWeight: "800",
    marginBottom: "8px",
  },

  insightTexto: {
    display: "block",
    fontSize: "13px",
    color: "rgba(255,255,255,0.82)",
    lineHeight: 1.5,
  },

  gridFormulario: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "14px",
    marginBottom: "16px",
  },

  gridEdicao: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginTop: "16px",
    marginBottom: "14px",
  },

  linhaFiltros: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    alignItems: "center",
    marginBottom: "18px",
  },

  gridFiltrosProdutos: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "12px",
    alignItems: "center",
    marginBottom: "18px",
  },

  label: {
    display: "block",
    marginBottom: "6px",
    fontSize: "13px",
    fontWeight: "700",
    color: "#334155",
  },

  input: {
    width: "100%",
    boxSizing: "border-box",
    height: "46px",
    borderRadius: "14px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    padding: "0 14px",
    fontSize: "14px",
    color: "#0f172a",
    outline: "none",
  },

  inputQuantidade: {
    width: "100%",
    boxSizing: "border-box",
    height: "46px",
    borderRadius: "14px",
    border: "1px solid rgba(255,255,255,0.25)",
    background: "rgba(255,255,255,0.16)",
    padding: "0 14px",
    fontSize: "14px",
    color: "#ffffff",
    outline: "none",
  },

  inputQuantidadeAlerta: {
    border: "1px solid rgba(0,0,0,0.10)",
    background: "rgba(255,255,255,0.45)",
    color: "#1e293b",
  },

  botaoPrimario: {
    background: "#163e7a",
    color: "#ffffff",
    border: "none",
    borderRadius: "14px",
    minHeight: "46px",
    padding: "0 18px",
    fontSize: "14px",
    fontWeight: "800",
    cursor: "pointer",
    boxShadow: "0 10px 20px rgba(22, 62, 122, 0.18)",
  },

  botaoSecundario: {
    background: "#dbeafe",
    color: "#163e7a",
    border: "1px solid #b6ccf5",
    borderRadius: "14px",
    minHeight: "46px",
    padding: "0 18px",
    fontSize: "14px",
    fontWeight: "800",
    cursor: "pointer",
  },

  botaoVerde: {
    background: "#22c55e",
    color: "#ffffff",
    border: "none",
    borderRadius: "14px",
    minHeight: "44px",
    padding: "0 16px",
    fontSize: "14px",
    fontWeight: "800",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(34,197,94,0.4)",
    transform: "scale(1.05)",
  },

  botaoAmarelo: {
    background: "#fbbf24",
    color: "#1e293b",
    border: "none",
    borderRadius: "14px",
    minHeight: "44px",
    padding: "0 16px",
    fontSize: "14px",
    fontWeight: "800",
    cursor: "pointer",
    boxShadow: "0 8px 18px rgba(251, 191, 36, 0.30)",
  },

  botaoPerigo: {
    background: "#ef4444",
    color: "#ffffff",
    border: "none",
    borderRadius: "14px",
    minHeight: "46px",
    padding: "0 18px",
    fontSize: "14px",
    fontWeight: "800",
    cursor: "pointer",
    boxShadow: "0 8px 18px rgba(239, 68, 68, 0.25)",
  },

  cardProduto: {
    background: "linear-gradient(135deg, #163e7a 0%, #1d4f91 45%, #2563eb 100%)",
    borderRadius: "22px",
    padding: "18px",
    marginBottom: "16px",
    boxShadow: "0 16px 34px rgba(22, 62, 122, 0.24)",
    border: "1px solid rgba(255,255,255,0.12)",
    color: "#ffffff",
  },

  cardProdutoAlerta: {
    background: "#ffee07",
    color: "#1e293b",
    border: "2px solid #000000",
  },

  topoProduto: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
    flexWrap: "wrap",
  },

  produtoEsquerda: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  iconeProduto: {
    width: "46px",
    height: "46px",
    borderRadius: "14px",
    background: "rgba(255,255,255,0.18)",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "800",
    fontSize: "18px",
    border: "1px solid rgba(255,255,255,0.18)",
  },

  iconeProdutoAlerta: {
    background: "rgba(255,255,255,0.35)",
    color: "#1e293b",
    border: "1px solid rgba(0,0,0,0.10)",
  },

  nomeProduto: {
    display: "block",
    fontSize: "18px",
    color: "#ffffff",
    fontWeight: "800",
  },

  nomeProdutoAlerta: {
    color: "#1e293b",
  },

  categoriaProduto: {
    marginTop: "4px",
    fontSize: "13px",
    color: "rgba(255,255,255,0.78)",
  },

  categoriaProdutoAlerta: {
    color: "#334155",
  },

  badgeAlerta: {
    display: "inline-flex",
    alignItems: "center",
    padding: "8px 12px",
    borderRadius: "999px",
    backgroundColor: "#1e293b",
    color: "#facc15",
    fontSize: "12px",
    fontWeight: "600",
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.22)",
  },

  badgeNormal: {
    display: "inline-flex",
    alignItems: "center",
    padding: "8px 12px",
    borderRadius: "999px",
    background: "#dcfce7",
    color: "#166534",
    fontSize: "12px",
    fontWeight: "800",
    boxShadow: "0 8px 18px rgba(34, 197, 94, 0.20)",
  },

  gridInfoPrincipal: {
    display: "grid",
    gridTemplateColumns: "minmax(180px, 220px)",
    gap: "12px",
    marginBottom: "14px",
  },

  infoBox: {
    background: "rgba(255,255,255,0.14)",
    border: "1px solid rgba(255,255,255,0.18)",
    borderRadius: "16px",
    padding: "12px",
    backdropFilter: "blur(4px)",
  },

  infoBoxAlerta: {
    background: "rgba(255,255,255,0.35)",
    border: "1px solid rgba(0,0,0,0.1)",
    backdropFilter: "blur(4px)",
  },

  infoTitulo: {
    display: "block",
    fontSize: "12px",
    color: "rgba(255,255,255,0.78)",
    marginBottom: "6px",
  },

  infoTituloAlerta: {
    color: "#475569",
  },

  infoValor: {
    fontSize: "15px",
    color: "#ffffff",
    fontWeight: "800",
  },

  infoValorAlerta: {
    color: "#1e293b",
  },

  infoValorEstoque: {
    fontSize: "20px",
    fontWeight: "700",
  },

  linhaQuantidadeAcoes: {
    display: "flex",
    gap: "12px",
    alignItems: "flex-end",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },

  quantidadeBox: {
    minWidth: "220px",
    flex: "1",
  },

  areaAcoes: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginTop: "8px",
  },

  painelEdicao: {
    marginTop: "16px",
    paddingTop: "16px",
    borderTop: "1px solid rgba(255,255,255,0.16)",
  },

  painelEdicaoAlerta: {
    borderTop: "1px solid rgba(0,0,0,0.12)",
  },

  areaAcoesEdicao: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginTop: "8px",
  },

  infoRodapeProduto: {
    marginTop: "12px",
    fontSize: "12px",
    color: "rgba(255,255,255,0.82)",
    lineHeight: 1.6,
  },

  infoRodapeProdutoAlerta: {
    color: "#334155",
  },

  itemRelatorio: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: "16px",
    padding: "14px",
    marginBottom: "10px",
    color: "#334155",
    lineHeight: 1.6,
  },

  toastContainer: {
    position: "fixed",
    top: "18px",
    right: "18px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    zIndex: 9999,
  },

  toast: {
    minWidth: "240px",
    maxWidth: "320px",
    padding: "14px 16px",
    borderRadius: "14px",
    fontSize: "14px",
    fontWeight: "700",
    boxShadow: "0 12px 24px rgba(15, 23, 42, 0.16)",
  },

  toastSucesso: {
    background: "#dcfce7",
    color: "#166534",
    border: "1px solid #86efac",
  },

  toastErro: {
    background: "#fee2e2",
    color: "#991b1b",
    border: "1px solid #fca5a5",
  },

  toastInfo: {
    background: "#dbeafe",
    color: "#1d4ed8",
    border: "1px solid #93c5fd",
  },
};